module.exports = __webpack_public_path__ + "img/frame (208).691d9e08.jpg";